import { StateManagementEnum } from "@/src/Config/enum";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CategoryState {
  productCategories: any[];
  blogCategories: any[];
  toolsCategories: any[];
}

const initialState: CategoryState = {
  productCategories: [],
  blogCategories: [],
  toolsCategories: [],
};

const categorySlice = createSlice({
  name: StateManagementEnum.CATEGORY,
  initialState,
  reducers: {
    setProductCategories(state, action: PayloadAction<any[]>) {
      state.productCategories = action.payload;
    },
    setBlogCategories(state, action: PayloadAction<any[]>) {
      state.blogCategories = action.payload;
    },
    setToolsCategories(state, action: PayloadAction<any[]>) {
      state.toolsCategories = action.payload;
    },
  },
});

export const { setProductCategories, setBlogCategories, setToolsCategories } =
  categorySlice.actions;
export default categorySlice.reducer;
